import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import FingerprintOne from '@grnhse/seedling/lib/birch/illustrations/fingerprint_one';
import { EmptyState } from '@grnhse/seedling/lib/birch/components/empty_state';
import { SecondaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { FORM_DEFAULTS } from 'talent_matching/components/filter_form';
import { useFiltersApplied } from 'talent_matching/hooks/use_people';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.table.no_results');

const NoResultsOverlay = () => {
  const filtersApplied = useFiltersApplied();
  const { reset } = useFormContext();

  const handleClearAll = () => {
    reset(FORM_DEFAULTS);
  };

  return (
    <Stack sx={{ marginTop: 5 }}>
      {filtersApplied ? (
        <EmptyState
          header={t('header')}
          body={t('body')}
          Illustration={FingerprintOne}
          size="sm"
        >
          <SecondaryButton onClick={handleClearAll}>
            {t('button')}
          </SecondaryButton>
        </EmptyState>
      ) : (
        <EmptyState
          header={t('empty')}
          body=""
          Illustration={FingerprintOne}
          size="sm"
        />
      )}
    </Stack>
  );
};

export default NoResultsOverlay;
